import { render } from "./Fila-Component.vue?vue&type=template&id=276c34a0&scoped=true"
import script from "./Fila-Component.vue?vue&type=script&lang=js"
export * from "./Fila-Component.vue?vue&type=script&lang=js"

import "./Fila-Component.vue?vue&type=style&index=0&id=276c34a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-276c34a0"]])

export default __exports__